import { TYPES as ICON_TYPES } from '../icon/constants';

export const TYPES = {
  ...ICON_TYPES,
  dark: 'dark',
};
